
  <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-6 col-md-6 col-xs-12">
          <alert [alert]="msg" style="display:block;"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-8 col-md-7 col-xs-12">
          <button type="button" class="btn btn-large btn-primary" (click)="add()">Add New</button>
          <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
      </div>
      <div class="col-lg-4 col-md-5 col-xs-8">
					<div class="input-group">
						<input class="form-control" type="text" (keyup.enter)="refresh()" [(ngModel)]="fobj.query" placeholder="Search"/>
						<span class="input-group-btn">
							<button class="btn btn-default" type="button" (click)="refresh()"> <span class="glyphicon glyphicon-search"></span> </button>
						</span>
					</div>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-12 col-md-12 col-xs-12">
        <div class="card">
          <table class="table">
            <thead>
              <tr>
                  <th>IdP Name</th>
                  <th>AcctNumber</th>
                  <th>Organization</th>
                  <th>Organization Mapping</th>
                  <th>Service Name</th>
                  <th>Service Roles</th>
                  <th>Service Roles Mapping</th>
                  <th>Updated At</th>
                  <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of data; let i = index">
                <td style="width:12%;">{{ row.idpName }}</td>
                <td style="width:12%;">{{ hexAcctNumber(row.orgAcctNumber) }}</td>
                <td style="width:12%;">{{ row.orgName }}</td>
                <td style="width:12%;">{{ row.accountGroups }}</td>
                <td style="width:12%;">{{ row.serviceId }}</td>
                <td style="width:11%;">
                <span class="tag" *ngFor="let role of row.serviceRoles.split(','); let j = index" style="padding: 2px 4px; display: inline-block; margin-bottom: 3px; margin-right: 3px;">{{role}}</span>
                </td>
                <td style="width:11%;">{{ row.serviceRolesGroups }}</td>
                <td style="width:11%;">{{ printDate(row.updatedAt) ? printDate(row.updatedAt) : printDate(row.createdAt) }}</td>
                <td style="width:7%;">
                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                    <span title="Remove Roles Mapping" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="remove(row)" style="cursor:pointer;"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" *ngIf="data.length > 0" style="margin-top:10px;">
          <div class="col-lg-5">
              <button class="btn btn-default" type="button" title="First Page" [disabled]="disablePreviousPage" (click)="firstPage()">&lt;&lt;</button>
              <button class="btn btn-default" type="button" title="Previous Page" [disabled]="disablePreviousPage" (click)="prevPage()">&lt;</button>
              <span>{{getFromPage()}}-{{getToPage()}} of {{rowCount}}</span>
              <button class="btn btn-default" type="button" title="Next Page" [disabled]="disableNextPage" (click)="nextPage()">&gt;</button>
          </div>
      </div>
    </div>
  